import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../components/Login.vue";
import Sportsbook from "../components/Sportsbook.vue";
import Widgets from "../components/Widgets.vue";
import Registration from "../components/Registration";
import getRandomLayout, { layouts } from "../getRandomLayout";

Vue.use(VueRouter);

const routes = [
  { path: "/registration", component: Registration },
  { path: "/login", component: Login },
  { path: "*", redirect: "/sportsbook" },
];

const Router = new VueRouter({
  mode: "history",
  routes: process.env.PRESENTATION
    ? [
        {
          path: "/sportsbook",
          redirect: `/sportsbook/${getRandomLayout()}`,
        },
        {
          path: "/casino",
          redirect: `/casino/${getRandomLayout()}`,
        },
        {
          path: `/sportsbook/:layout(${layouts.join("|")})?*`,
          component: Sportsbook,
        },
        { path: `/casino/:layout(${layouts.join("|")})?*`, component: Widgets },
        ...routes,
      ]
    : [
        { path: "/sportsbook*", component: Sportsbook },
        { path: "/casino*", component: Widgets },
        ...routes,
      ],
});

Router.beforeEach((to, from, next) => {
  if (
    from.fullPath.startsWith("/sportsbook") &&
    (to.fullPath.startsWith("/registration") ||
      to.fullPath.startsWith("/login")) &&
    !to.query.returnToPath
  ) {
    next({
      path: to.path,
      query: {
        returnToPath: encodeURIComponent(
          window.location.pathname + window.location.search
        ),
      },
    });
  } else if (
    (from.fullPath.startsWith("/registration") ||
      from.fullPath.startsWith("/login")) &&
    to.fullPath.startsWith("/sportsbook") &&
    from.query.returnToPath &&
    decodeURIComponent(from.query.returnToPath) !== to.fullPath
  ) {
    next({
      path: decodeURIComponent(from.query.returnToPath),
    });
  } else if (
    (to.fullPath.startsWith("/registration") ||
      to.fullPath.startsWith("/login")) &&
    from.query.returnToPath &&
    !to.query.returnToPath
  ) {
    next({
      path: to.path,
      query: { returnToPath: from.query.returnToPath },
    });
  } else {
    next();
  }
});

export default Router;
